import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getPaginatorLabels } from './app-locale';

@Injectable()
export class AppPaginatorIntl extends MatPaginatorIntl {
    setLanguage(language: string): void {
        const labels = getPaginatorLabels(language);
        this.itemsPerPageLabel = labels.itemsPerPageLabel;
        this.nextPageLabel = labels.nextPageLabel;
        this.previousPageLabel = labels.previousPageLabel;
        this.firstPageLabel = labels.firstPageLabel;
        this.lastPageLabel = labels.lastPageLabel;
        this.getRangeLabel = labels.getRangeLabel;
        this.changes.next();
    }
}
